/*
{"message":{"subject":"PIVUXT95","subjectType":1,"context":{"templateId":"lilly-rx-transfer","templateVersion":1,"clientId":null,"oAuthSubject":null,"responseRoute":"workflow-service-lilly-rx-transfer-by-account","correlationId":"83267435-7eeb-4ce9-9903-1f73a76d500e","channel":{"channelType":"sms","channelTarget":"+14256007186"},"createDateTime":"2025-08-26T00:08:28.8373884Z"}},"signature":"C4-A0-12-BD-47-17-2F-11-DD-02-BA-B7-5F-7A-FA-EC-F6-57-15-58-4A-2A-F9-CD-95-69-D1-33-99-41-13-13"}
 */

export type Channel = {
    channelType: string;
    channelTarget: string;
};

export type Context = {
    templateId: string;
    templateVersion: number;
    clientId: string | null;
    oAuthSubject: string | null;
    responseRoute: string;
    correlationId: string;
    channel: Channel;
    createDateTime: string;
};

export type Message = {
    subject: string;
    subjectType: number;
    context: Context;
};

export type NotificationContext = {
    message: Message;
    signature: string;
};

/**
 * Decodes a base64-encoded notification context string into a NotificationContext object
 * @param ctx - Base64-encoded notification context string
 * @returns The decoded NotificationContext object or null if decoding fails
 */
export const decodeContext = (ctx: string): NotificationContext | null => {
    try {
        // Decode base64 string to UTF-8
        const decodedString = atob(ctx);

        // Parse the JSON string into an object
        const parsedContext = JSON.parse(decodedString) as NotificationContext;

        return parsedContext;
    } catch (error) {
        // oxlint-disable-next-line no-console
        console.error(
            `Failed to decode notification context: ${error instanceof Error ? error.message : String(error)}`
        );
        return null;
    }
};
